module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_3016.278f72a4.png";